import { render, staticRenderFns } from "./_qv-sales-analysis.vue?vue&type=template&id=05848e13&scoped=true"
import script from "./_qv-sales-analysis.vue?vue&type=script&lang=js"
export * from "./_qv-sales-analysis.vue?vue&type=script&lang=js"
import style0 from "./_qv-sales-analysis.vue?vue&type=style&index=0&id=05848e13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05848e13",
  null
  
)

export default component.exports